import { Text } from '@chakra-ui/react';
import { IconChevronTopSmall } from 'central-icons/IconChevronTopSmall';

import type { TreeData } from '@revelio/ui';
import { Button, Checkbox, Collapse, useDisclosure } from '@revelio/ui';

import styles from './selected-value-display.module.css';

export function SelectedValuesDisplayComponent({
  selections,
  onRemove,
}: {
  selections: TreeData[];
  onRemove?: (selectionId: string) => void;
}) {
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: true });

  if (selections.length === 0) {
    return null;
  }

  return (
    <div className={styles.root}>
      <div className={styles.toggleRow}>
        <Button
          size="sm"
          variant="link"
          color="secondary"
          className={styles.toggleButton}
          onClick={onToggle}
        >
          <Text fontWeight={600} fontSize="sm">
            {`${selections.length} Selected`}
          </Text>
          <IconChevronTopSmall
            size={28}
            className={styles.chevron}
            data-open={isOpen || undefined}
          />
        </Button>
      </div>
      <Collapse open={isOpen}>
        <div
          className={styles.scrollArea}
          onWheel={(e) => {
            e.stopPropagation();
          }}
        >
          <div className={styles.selectionList}>
            {selections.map((selection) => (
              <Checkbox
                key={selection.id}
                checked
                onChange={(e) => {
                  if (!e.target.checked && onRemove) {
                    onRemove(selection.id);
                  }
                }}
              >
                <Text
                  fontSize="var(--ui-font-size-x-sm)"
                  color="text.primary"
                  noOfLines={1}
                  whiteSpace="nowrap"
                  overflow="hidden"
                  textOverflow="ellipsis"
                >
                  {selection.name}
                </Text>
              </Checkbox>
            ))}
          </div>
        </div>
      </Collapse>
    </div>
  );
}
